<template>
    <div class="input-group plugin__search-bar">
        <div class="input-group-btn plugin__search-button">
            <button class="btn btn-link" @click="executeSearch">
                <i class="far fa-search"></i>
            </button>
        </div>
        <input id="photostreamSearch" placeholder="Search" v-model="search" class="form-control plugin__search-input"
          @keydown.enter.exact.prevent
          @keyup.enter.exact="executeSearch"
          v-on:input="updateValue"
        >
        <div class="input-group-btn plugin__search-right">
            <a class="btn btn-link plugin__search-inner" @click="executeSearch">
                <i class="fas fa-arrow-right plugin__search-arrow"></i>
            </a>
        </div>
    </div>
</template>

<script>

export default {
  props: ["value"],

  data() {
    return {
      search: ''
    }
  },

  methods: {
    executeSearch: function() {
        this.$parent.$emit('search-value', this.search);
    },

    updateValue(){
      if(this.search.length == 0){
        this.$parent.$emit('search-value');
      }
    }
    
  },

  watch: {
    // search (val) {
       // console.log('new search:', val)
    // }
  }
};
</script>